import { render, staticRenderFns } from "./DeliveryIndicator.vue?vue&type=template&id=19e57161&"
import script from "./DeliveryIndicator.vue?vue&type=script&lang=ts&"
export * from "./DeliveryIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports